import { render, staticRenderFns } from "./onsite.vue?vue&type=template&id=68d6332b&scoped=true"
import script from "./onsite.vue?vue&type=script&lang=js"
export * from "./onsite.vue?vue&type=script&lang=js"
import style0 from "./onsite.vue?vue&type=style&index=0&id=68d6332b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6332b",
  null
  
)

export default component.exports